<template>
  <b-modal
    v-model="showModal"
    id="enterAdjustmentModal"
    :title="$t('adjustment_modal_title')"
    centered
    @hidden="clear"
  >
    <b-form class="enter-adjustment-form">
      <info-row class="info-main-row" :title="$t('adjustment_modal_amount_label')">
        <currency-input
          :name="$t('payment_modal_amount_label')"
          :amount.sync="amount"
          :fieldState="fieldState.amount"
        />
      </info-row>

      <info-row class="info-main-row" :title="$t('description')">
        <b-col class="input-group">
          <b-form-input
            v-model="description"
            :title="$t('description')"
            type="text"
            required
            class="form-control"
          />
        </b-col>
      </info-row>
    </b-form>

    <div slot="modal-footer" class="w-100">
      <span class="text-danger">{{ warningText }}</span>
      <b-btn
        class="float-right"
        variant="success"
        @click="submitAdjustment"
      >
        {{ $t('adjustment_modal_button') }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'EnterAdjustmentModal',

  components: {
    InfoRow: () => import('@/components/InfoRow'),
    CurrencyInput: () => import('@/components/widgets/CurrencyInput')
  },

  data() {
    return {
      showModal: null,
      amount: 0,
      modifier: null,
      description: '',
      warningText: '',
      fieldState: { //true is valid, false shows the red invalid
        amount: null,
      },
    }
  },

  methods: {
    show (modifier) {
      this.modifier = modifier;
      this.description = this.modifier
        ? this.modifier.name
        : 'Unknown Modifier';

      this.showModal = true;
    },

    hide () {
      this.showModal = false;
    },

    submitAdjustment() {
      this.fieldState.amount = !!this.amount && this.amount > 0

      if (!this.fieldState.amount || !this.modifier){
        return;
      }

      const modifierData = {
        modifier_id: this.modifier.id,
        rate: this.amount,
        description: this.modifier.name,
        name: this.modifier.name,
      }

      this.$emit('submit', this.modifier.category_id, this.amount);

      this.clear();
    },

    clear() {
      this.amount = 0;
      this.warningText = '';
      this.modifier = null;
      this.showModal = false;

      this.fieldState = {
        amount: null,
      }
    }
  },
};
</script>

<style lang="scss">
#enterAdjustmentModal {
  .modal-header {
    height: initial;
    width: initial;
  }

  .modal-open {
    margin: auto;
  }
}
</style>
